// Central data file for BRS Terasz website

// ============ PRODUCT GROUPS ============
export const productGroups = [
  {
    id: "aluminium-teraszok",
    name: "Alumínium teraszok",
    description: "Tartós, karbantartásmentes alumínium teraszok nyitott, üvegezett és szabadon álló kivitelben.",
    image: "/images/aluminium-teraszok/aluminium-teraszok-1.webp",
    subcategories: ["nyitott-teraszok", "eltolhato-uvegfalu-teraszok", "szabadonallo-teraszok"]
  },
  {
    id: "teraszfedesek",
    name: "Teraszfedések",
    description: "Üveg és polikarbonát terasztetők elegáns és tartós megoldásokkal.",
    image: "/images/teraszfedesek/teraszfedes-3.webp",
    subcategories: ["uveg-terasztetok", "polikarbonat-terasztetok"]
  },
  {
    id: "arnyekolok",
    name: "Árnyékolók",
    description: "ZIP screen technológiás oldal- és tetőárnyékolók a tökéletes komfortért.",
    image: "/images/arnyekolok/ref-arnyekolo-1.webp",
    subcategories: ["oldalarnyekolo", "tetoarnyekolo"]
  },
  {
    id: "kocsibeallok",
    name: "Kocsibeállók",
    description: "Stílusos, tartós alumínium kocsibeállók autója védelméért.",
    image: "/images/kocsibeallok/kocsi4.webp",
    subcategories: ["kocsibeallok"]
  }
];

// ============ INDIVIDUAL PRODUCTS ============
export const products = {
  "nyitott-teraszok": {
    name: "Nyitott teraszok",
    group: "aluminium-teraszok",
    groupName: "Alumínium teraszok",
    headline: "Fedett, de nyitott kültéri élettér",
    description: "Nyitott alumínium teraszaink elegáns és tartós megoldást kínálnak a kültéri élet számára. Az alumínium szerkezet ellenáll az időjárás viszontagságainak, nem korhad és nem vetemedik. Különböző tetőfedési lehetőségek közül választhat, és a standard színválaszték mellett egyedi színeket is készítünk kérésre.",
    image: "/images/aluminium-teraszok/aluminium-teraszok-1.webp",
    features: [
      "Alumínium szerkezet",
      "Különböző tetőfedési lehetőségek",
      "Standard színek: antracit, fekete, fehér, szürke",
      "Egyedi színek kérésre",
      "Beépített esővíz-elvezetés",
      "Egyedi méretre gyártás"
    ],
    benefits: [
      { title: "Időjárásálló", desc: "Az alumínium nem korhad, nem reped és nem vetemedik." },
      { title: "Minimális karbantartás", desc: "Nincs szükség festésre, csiszolásra - elég egy egyszerű lemosás." },
      { title: "Értéknövelő", desc: "Jelentősen növeli ingatlanja értékét és használható élőterét." }
    ],
    refKey: "aluminium-teraszok"
  },
  "eltolhato-uvegfalu-teraszok": {
    name: "Eltolható üvegfalú teraszok",
    group: "aluminium-teraszok",
    groupName: "Alumínium teraszok",
    headline: "Nyitható-zárható üvegezett teraszok",
    description: "Eltolható üvegfalú teraszaink tökéletes megoldást nyújtanak, ha egész évben szeretné használni a teraszt. A nagy üvegpanelek szélvédelmet és esővédelmet biztosítanak, miközben szép időben teljesen kinyithatók. Az alumínium vázszerkezet elegáns és tartós.",
    image: "/images/aluminium-teraszok/eltolhato-uvegfalu-1.webp",
    features: [
      "Eltolható üvegpanelek",
      "Alumínium vázszerkezet",
      "Szélvédelem és esővédelem",
      "Standard színek: antracit, fekete, fehér, szürke",
      "Egyedi méretezés",
      "Hőszigetelő üveg opció"
    ],
    benefits: [
      { title: "Egész éves használat", desc: "Zárva védelem az időjárás ellen, nyitva szabad levegő." },
      { title: "Természetes fény", desc: "A nagy üvegfelületek rengeteg fényt engednek be." },
      { title: "Rugalmasság", desc: "Pillanatok alatt nyitható és zárható az igényeknek megfelelően." }
    ],
    refKey: "aluminium-teraszok"
  },
  "szabadonallo-teraszok": {
    name: "Szabadon álló teraszok",
    group: "aluminium-teraszok",
    groupName: "Alumínium teraszok",
    headline: "Független alumínium teraszok",
    description: "Szabadon álló teraszaink nem igényelnek fali rögzítést, így a kert bármely pontjára elhelyezhetők. A stabil alumínium oszlopok és gerendák biztosítják a szerkezet szilárdságát még erős szélben is. Különböző fedési opciók közül választhat.",
    image: "/images/aluminium-teraszok/szabadon-allo-teraszok-1.webp", alt: "Szabadon álló terasz 1",
	features: [
      "Fali rögzítés nélkül",
      "Szabadon pozícionálható",
      "Alumínium oszlopok és gerendák",
      "Standard színek: antracit, fekete, fehér, szürke",
      "Stabil, szélálló szerkezet",
      "Különböző fedési opciók"
    ],
    benefits: [
      { title: "Szabad elhelyezés", desc: "A kert bármely pontján felállítható, nem kell fali rögzítés." },
      { title: "Tartós szerkezet", desc: "Alumínium oszlopok és gerendák évtizedekig szolgálnak." },
      { title: "Egyedi kialakítás", desc: "Méretre és igényekre szabott megoldások." }
    ],
    refKey: "aluminium-teraszok"
  },
  "uveg-terasztetok": {
    name: "Üveg terasztetők",
    group: "teraszfedesek",
    groupName: "Teraszfedések",
    headline: "Átlátszó üveg terasztetők",
    description: "Üveg terasztetőink maximális természetes fényt biztosítanak, miközben megbízhatóan védelmet nyújtanak az eső és a szél ellen. Az edzett biztonsági üveg és az önhordó alumínium szerkezet kombinációja elegáns és tartós megoldást eredményez.",
    image: "/images/teraszfedesek/teraszfedes-2.webp",
    features: [
      "Edzett biztonsági üveg",
      "Önhordó alumínium szerkezet",
      "Beépített esővíz-elvezetés",
      "Standard színek: antracit, fekete, fehér, szürke",
      "UV szűrős üveg opció",
      "Egyedi méretezés"
    ],
    benefits: [
      { title: "Maximum fény", desc: "Az üveg fedés engedi át a legtöbb természetes fényt." },
      { title: "Prémium megjelenés", desc: "Elegáns, modern megjelenés bármilyen építészeti stílushoz." },
      { title: "Tartósság", desc: "Az edzett biztonsági üveg ellenáll a legszélsőségesebb időjárásnak is." }
    ],
    refKey: "teraszfedesek"
  },
  "polikarbonat-terasztetok": {
    name: "Polikarbonát terasztetők",
    group: "teraszfedesek",
    groupName: "Teraszfedések",
    headline: "Könnyű és tartós polikarbonát fedés",
    description: "Polikarbonát terasztetőink 16 és 25 mm-es panelekkel készülnek, melyek kiválóan szűrik az UV sugarakat és jó hőszigetelést biztosítanak. Két színben érhető el: opál (tejfehéres, fényszűrő) és víztiszta (átlátszó). Könnyű szerkezetük és kimagasló teherbírásuk teszi őket ideális választássá.",
    image: "/images/teraszfedesek/teraszfedes-8.webp",
    features: [
      "16 mm és 25 mm vastagság",
      "Opál vagy víztiszta színben",
      "UV álló",
      "Könnyű szerkezet",
      "Jó hőszigetelés",
      "Alumínium vázszerkezet"
    ],
    benefits: [
      { title: "Kiváló ár-érték", desc: "Megfizethető megoldás prémium minőségben." },
      { title: "Választható szín", desc: "Opál (fényszűrő) vagy víztiszta (átlátszó) kialakítás." },
      { title: "Könnyű telepítés", desc: "A könnyű panelek gyors és hatékony telepítést tesznek lehetővé." }
    ],
    refKey: "teraszfedesek"
  },
  "oldalarnyekolo": {
    name: "Oldalárnyékoló",
    group: "arnyekolok",
    groupName: "Árnyékolók",
    headline: "Oldalirányú ZIP screen árnyékolás",
    description: "ZIP screen technológiás oldalárnyékolóink tökéletes szél- és napvédelmet biztosítanak. A ZIP rendszer a szövet széleit alumínium vezetősínbe zárja, így a szövet még erős szélben sem lobog. Motoros vagy kézi vezérléssel érhetők el, és széles szövet- és színválasztékkal rendelkeznek.",
    image: "/images/arnyekolok/ref-arnyekolo-1.webp",
    features: [
      "ZIP screen technológia",
      "Szél- és UV védelem",
      "Motoros vagy kézi vezérlés",
      "Standard színek: antracit, fekete, fehér, szürke",
      "Különböző szövetválaszték",
      "Alumínium vezetősín"
    ],
    benefits: [
      { title: "Szélálló", desc: "A ZIP rendszer biztosítja, hogy a szövet még erős szélben is a helyén maradjon." },
      { title: "Hatékony árnyékolás", desc: "Tökéletes napvédelem és hővédelem egész évben." },
      { title: "Modern megjelenés", desc: "Diszkrét, elegáns kialakítás ami illeszkedik bármilyen homlokzathoz." }
    ],
    refKey: "arnyekolok"
  },
  "tetoarnyekolo": {
    name: "Tetőárnyékoló",
    group: "arnyekolok",
    groupName: "Árnyékolók",
    headline: "Tetőre szerelhető ZIP screen árnyékoló",
    description: "Tetőárnyékolóink ZIP screen technológiával készülnek, és hatékony hővédelmet biztosítanak. Az üveg- vagy polikarbonát terasztetők alá szerelhetők, így nyáron megakadályozzák a túlzott felmelegedést. Motoros vezérléssel kényelmesen kezelhetők.",
    image: "/images/arnyekolok/ref-arnyekolo-2.webp",
    features: [
      "ZIP screen technológia",
      "Hatékony hővédelem",
      "Motoros vezérlés",
      "Standard alumínium színek",
      "Integrált alumínium vezetősín",
      "Szélálló kialakítás"
    ],
    benefits: [
      { title: "Hővédelem", desc: "Nyáron akár 10-15 fokkal csökkenti a teraszon a hőmérsékletet." },
      { title: "Energiatakarékos", desc: "Csökkenti a belső terek hűtési igényét." },
      { title: "Automatizálható", desc: "Időzítővel és napfényérzékelővel is kiegészíthető." }
    ],
    refKey: "arnyekolok"
  },
  "kocsibeallok": {
    name: "Kocsibeállók",
    group: "kocsibeallok",
    groupName: "Kocsibeállók",
    headline: "Stílusos védelem autójának",
    description: "Alumínium kocsibeállóink elegáns és tartós megoldást nyújtanak autója védelmére. Egy vagy több autós kivitelben, polikarbonát vagy üveg fedéssel. A standard színek (antracit, fekete, fehér, szürke) mellett egyedi színeket is készítünk kérésre.",
    image: "/images/kocsibeallok/kocsi4.webp",
    features: [
      "1-3 autós kivitelek",
      "Polikarbonát vagy üveg fedés",
      "UV szűrő bevonat",
      "Standard színek: antracit, fekete, fehér, szürke",
      "Integrált esővíz-elvezetés",
      "Oldalfal opciók"
    ],
    benefits: [
      { title: "UV védelem", desc: "Megóvja autója fényezését a napsugaraktól." },
      { title: "Időjárás ellen", desc: "Véd az esőtől, hótól és jégesőtől." },
      { title: "Tartós szerkezet", desc: "Nem igényel karbantartást, évtizedekig szolgál." }
    ],
    refKey: "kocsibeallok"
  }
};

// ============ REFERENCE IMAGES ============
export const referenceImages = {
  "aluminium-teraszok": [
    { id: 1, src: "/images/aluminium-teraszok/aluminium-teraszok-1.webp", alt: "Alumínium terasz 1" },
    { id: 2, src: "/images/aluminium-teraszok/aluminium-teraszok-2.webp", alt: "Alumínium terasz 2" },
    { id: 3, src: "/images/aluminium-teraszok/aluminium-teraszok-3.webp", alt: "Alumínium terasz 3" },
    { id: 4, src: "/images/aluminium-teraszok/aluminium-teraszok-4.webp", alt: "Alumínium terasz 4" },
	{ id: 26, src: "/images/aluminium-teraszok/aluminium-teraszok-5.webp", alt: "Alumínium terasz 5" },
    { id: 27, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-1.webp", alt: "Eltolható üvegfalú terasz 1" },
    { id: 28, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-2.webp", alt: "Eltolható üvegfalú terasz 2" },
    { id: 29, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-3.webp", alt: "Eltolható üvegfalú terasz 3" },
	{ id: 30, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-4.webp", alt: "Eltolható üvegfalú terasz 4" },
    { id: 31, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-5.webp", alt: "Eltolható üvegfalú terasz 5" },
    { id: 32, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-6.webp", alt: "Eltolható üvegfalú terasz 6" },
    { id: 33, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-7.webp", alt: "Eltolható üvegfalú terasz 7" },
	{ id: 34, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-8.webp", alt: "Eltolható üvegfalú terasz 8" },
    { id: 35, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-9.webp", alt: "Eltolható üvegfalú terasz 9" },
    { id: 36, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-10.webp", alt: "Eltolható üvegfalú terasz 10" },
    { id: 37, src: "/images/aluminium-teraszok/eltolhato-uvegfalu-11.webp", alt: "Eltolható üvegfalú terasz 11" },
	{ id: 38, src: "/images/aluminium-teraszok/szabadon-allo-teraszok-1.webp", alt: "Szabadon álló terasz 1" },
    { id: 39, src: "/images/aluminium-teraszok/szabadon-allo-teraszok-2.webp", alt: "Szabadon álló terasz 2" },
    { id: 40, src: "/images/aluminium-teraszok/szabadon-allo-teraszok-3.webp", alt: "Szabadon álló terasz 3" },
    { id: 41, src: "/images/aluminium-teraszok/lepcso-1.webp", alt: "Lépcső terasz 1" },
    { id: 42, src: "/images/aluminium-teraszok/lepcso-2.webp", alt: "Lépcső terasz 2" },
    { id: 43, src: "/images/aluminium-teraszok/lepcso-3.webp", alt: "Lépcső terasz 3" }, 
  ],
  "teraszfedesek": [
    { id: 5, src: "/images/teraszfedesek/teraszfedes-1.webp", alt: "Teraszfedés 1" },
    { id: 6, src: "/images/teraszfedesek/teraszfedes-2.webp", alt: "Teraszfedés 2" },
    { id: 7, src: "/images/teraszfedesek/teraszfedes-3.webp", alt: "Teraszfedés 3" },
    { id: 8, src: "/images/teraszfedesek/teraszfedes-4.webp", alt: "Teraszfedés 4" },
    { id: 21, src: "/images/teraszfedesek/teraszfedes-5.webp", alt: "Teraszfedés 5" },
    { id: 22, src: "/images/teraszfedesek/teraszfedes-6.webp", alt: "Teraszfedés 6" },
    { id: 23, src: "/images/teraszfedesek/teraszfedes-7.webp", alt: "Teraszfedés 7" },
    { id: 24, src: "/images/teraszfedesek/teraszfedes-8.webp", alt: "Teraszfedés 8" },
	{ id: 25, src: "/images/teraszfedesek/teraszfedes-9.webp", alt: "Teraszfedés 9" },
  ],
  "arnyekolok": [
    { id: 9, src: "/images/arnyekolok/ref-arnyekolo-1.webp", alt: "Árnyékoló 1" },
    { id: 10, src: "/images/arnyekolok/ref-arnyekolo-2.webp", alt: "Árnyékoló 2" },
    { id: 11, src: "/images/arnyekolok/ref-arnyekolo-3.webp", alt: "Árnyékoló 3" },
    { id: 12, src: "/images/arnyekolok/ref-arnyekolo-4.webp", alt: "Árnyékoló 4" },
  ],
  "kocsibeallok": [
    { id: 13, src: "/images/kocsibeallok/kocsi4.webp", alt: "Kocsibeálló 1" },
    { id: 14, src: "/images/kocsibeallok/kocsi2.webp", alt: "Kocsibeálló 2" },
    { id: 15, src: "/images/kocsibeallok/kocsi3.webp", alt: "Kocsibeálló 3" },
    { id: 16, src: "/images/kocsibeallok/kocsi1.webp", alt: "Kocsibeálló 4" },
  ],
  "teraszkorlatok": [
    { id: 17, src: "/images/korlatok/ref-korlat-1.webp", alt: "Teraszkorlát 1" },
    { id: 18, src: "/images/korlatok/ref-korlat-2.webp", alt: "Teraszkorlát 2" },
    { id: 19, src: "/images/korlatok/ref-korlat-3.webp", alt: "Teraszkorlát 3" },
    { id: 20, src: "/images/korlatok/ref-korlat-4.webp", alt: "Teraszkorlát 4" },
  ],
};

// ============ REFERENCE FILTER LABELS ============
export const referenceFilterLabels = {
  osszes: "Összes",
  "aluminium-teraszok": "Alumínium teraszok",
  "teraszfedesek": "Teraszfedések",
  "arnyekolok": "Árnyékolók",
  "kocsibeallok": "Kocsibeállók",
  "teraszkorlatok": "Teraszkorlátok",
};

// ============ NAVIGATION ============
export const navProductGroups = [
  {
    name: "Alumínium teraszok",
    items: [
      { name: "Nyitott teraszok", path: "/termekek/nyitott-teraszok" },
      { name: "Eltolható üvegfalú teraszok", path: "/termekek/eltolhato-uvegfalu-teraszok" },
      { name: "Szabadon álló teraszok", path: "/termekek/szabadonallo-teraszok" },
    ]
  },
  {
    name: "Teraszfedések",
    items: [
      { name: "Üveg terasztetők", path: "/termekek/uveg-terasztetok" },
      { name: "Polikarbonát terasztetők", path: "/termekek/polikarbonat-terasztetok" },
    ]
  },
  {
    name: "Árnyékolók",
    items: [
      { name: "Oldalárnyékoló", path: "/termekek/oldalarnyekolo" },
      { name: "Tetőárnyékoló", path: "/termekek/tetoarnyekolo" },
    ]
  },
  {
    name: "Kocsibeállók",
    items: [
      { name: "Kocsibeállók", path: "/termekek/kocsibeallok" },
    ]
  }
];

export const navReferenceItems = [
  { name: "Alumínium teraszok", path: "/referenciak?filter=aluminium-teraszok" },
  { name: "Teraszfedések", path: "/referenciak?filter=teraszfedesek" },
  { name: "Árnyékolók", path: "/referenciak?filter=arnyekolok" },
  { name: "Kocsibeállók", path: "/referenciak?filter=kocsibeallok" },
  { name: "Teraszkorlátok", path: "/referenciak?filter=teraszkorlatok" },
];

// ============ BLOG POSTS ============
export const blogPosts = [
  {
    slug: "aluminium-vagy-fa-terasz",
    title: "Alumínium vagy fa terasz? Melyiket válasszam?",
    excerpt: "Részletes összehasonlítás a két legnépszerűbb anyag között. Előnyök, hátrányok, költségek.",
    category: "tippek",
    categoryLabel: "Tippek és tanácsok",
    date: "2026. január 15.",
    author: "BRS Terasz",
    image: "/images/aluminium-teraszok/aluminium-teraszok-4.webp",
    readTime: "5 perc olvasás",
    refKey: "aluminium-teraszok"
  },
  {
    slug: "uveg-vagy-polikarbonat-teraszfedes",
    title: "Üveg vagy polikarbonát teraszfedés? Összehasonlítás",
    excerpt: "Mindkét megoldásnak megvannak az előnyei. Segítünk a döntésben!",
    category: "tippek",
    categoryLabel: "Tippek és tanácsok",
    date: "2026. január 8.",
    author: "BRS Terasz",
    image: "/images/teraszfedesek/teraszfedes-9.webp",
    readTime: "4 perc olvasás",
    refKey: "teraszfedesek"
  },
  {
    slug: "zip-screen-arnyekolok-elonyei",
    title: "ZIP screen árnyékolók: A modern megoldás",
    excerpt: "Miért a ZIP screen technológia a legmodernebb árnyékolási megoldás? Összegyűjtöttük az előnyöket.",
    category: "tippek",
    categoryLabel: "Tippek és tanácsok",
    date: "2026. január 3.",
    author: "BRS Terasz",
    image: "/images/arnyekolok/ref-arnyekolo-1.webp",
    readTime: "5 perc olvasás",
    refKey: "arnyekolok"
  },
  {
    slug: "kocsibeallo-valasztasi-utmutato",
    title: "Hogyan válasszunk kocsibeállót? Útmutató",
    excerpt: "Minden amit tudni kell a kocsibeálló vásárlás előtt: méretek, anyagok, telepítés.",
    category: "tippek",
    categoryLabel: "Tippek és tanácsok",
    date: "2025. december 20.",
    author: "BRS Terasz",
    image: "/images/kocsibeallok/kocsi4.webp",
    readTime: "5 perc olvasás",
    refKey: "kocsibeallok"
  },
  {
    slug: "terasz-trendek-2025",
    title: "Terasz trendek 2026-ben: A legújabb stílusok",
    excerpt: "Fedezze fel a 2026-os év legmenőbb terasz és árnyékolási trendjeit. Színek, anyagok, formák.",
    category: "inspiraciok",
    categoryLabel: "Inspirációk",
    date: "2025. december 12.",
    author: "BRS Terasz",
    image: "/images/aluminium-teraszok/szabadon-allo-teraszok-1.webp",
    readTime: "6 perc olvasás",
    refKey: "aluminium-teraszok"
  },
];

// ============ BLOG POST FULL CONTENT ============
export const blogPostsData = {
  "aluminium-vagy-fa-terasz": {
    title: "Alumínium vagy fa terasz? Melyiket válasszam?",
    excerpt: "Részletes összehasonlítás a két legnépszerűbb anyag között.",
    category: "Tippek és tanácsok",
    date: "2026. január 15.",
    author: "BRS Terasz",
    image: "/images/aluminium-teraszok/aluminium-teraszok-4.webp",
    readTime: "5 perc olvasás",
    refKey: "aluminium-teraszok",
    content: `
      <p>A teraszfedés anyagának kiválasztása az egyik legfontosabb döntés, amit meg kell hoznia. A két legnépszerűbb választás az alumínium és a fa. De melyik a jobb? Ebben a cikkben részletesen összehasonlítjuk a két anyagot.</p>

      <h2>Alumínium előnyei</h2>
      <ul>
        <li><strong>Tartósság:</strong> Az alumínium nem korhad, nem reped és nem vetemedik. Ellenáll az időjárás viszontagságainak évtizedeken át.</li>
        <li><strong>Minimális karbantartás:</strong> Nem igényel rendszeres festést, lakkozást vagy egyéb felületkezelést.</li>
        <li><strong>Színválaszték:</strong> Standard színeink (antracit, fekete, fehér, szürke) mellett egyedi színeket is készítünk.</li>
        <li><strong>Értékállóság:</strong> Hosszú távon költséghatékonyabb, mivel nem kell folyamatosan karbantartani.</li>
      </ul>

      <h2>Fa előnyei</h2>
      <ul>
        <li><strong>Természetes megjelenés:</strong> Meleg, természetes hatás, amely jól illeszkedik klasszikus stílusú házakhoz.</li>
        <li><strong>Alacsonyabb kezdeti költség:</strong> A fa szerkezetek általában olcsóbbak az alumíniumnál.</li>
      </ul>

      <h2>Fa hátrányai</h2>
      <ul>
        <li><strong>Karbantartás igény:</strong> 2-3 évente festeni vagy lakkozni kell.</li>
        <li><strong>Korhad és vetemedik:</strong> Az időjárás hatására károsodhat.</li>
        <li><strong>Rovarok:</strong> Farontó rovarok károsíthatják.</li>
      </ul>

      <h2>Összegzés</h2>
      <p>Ha hosszú távra tervez és szeretne megszabadulni a rendszeres karbantartás gondjától, az alumínium a jobb választás. Nyitott, eltolható üvegfalú vagy szabadon álló teraszainkról bővebben a termékek oldalon tájékozódhat.</p>
    `
  },
  "uveg-vagy-polikarbonat-teraszfedes": {
    title: "Üveg vagy polikarbonát teraszfedés? Összehasonlítás",
    excerpt: "Mindkét megoldásnak megvannak az előnyei. Segítünk a döntésben!",
    category: "Tippek és tanácsok",
    date: "2026. január 8.",
    author: "BRS Terasz",
    image: "/images/teraszfedesek/teraszfedes-9.webp",
    readTime: "4 perc olvasás",
    refKey: "teraszfedesek",
    content: `
      <p>A teraszfedés kiválasztásánál az egyik leggyakoribb kérdés: üveg vagy polikarbonát? Mindkettő kiváló megoldás, de más-más előnyökkel rendelkeznek. Segítünk a döntésben!</p>

      <h2>Üveg terasztetők</h2>
      <ul>
        <li><strong>Prémium megjelenés:</strong> Az üveg elegáns, modern hatást kelt.</li>
        <li><strong>Tartósság:</strong> Edzett biztonsági üveget használunk, ami ellenáll a szélsőséges időjárásnak.</li>
        <li><strong>Tiszta kilátás:</strong> Tökéletes átlátszóság, semmi nem zavarja a panorámát.</li>
        <li><strong>UV szűrő opció:</strong> Kérhető UV szűrős üveg is a felesleges napsugárzás ellen.</li>
      </ul>

      <h2>Polikarbonát terasztetők</h2>
      <ul>
        <li><strong>Kedvező ár:</strong> Az üvegnél megfizethetőbb, de rendkívül tartós megoldás.</li>
        <li><strong>Két vastagság:</strong> 16 mm és 25 mm-es panelekből választhat.</li>
        <li><strong>Színválaszték:</strong> Opál (tejfehéres, fényszűrő) és víztiszta (átlátszó) színben érhető el.</li>
        <li><strong>Könnyű szerkezet:</strong> Az üvegnél jóval könnyebb, gyorsabb telepítés.</li>
        <li><strong>Jó hőszigetelés:</strong> A többrétegű polikarbonát kiválóan szigetel.</li>
      </ul>

      <h2>Mikor melyiket válasszam?</h2>
      <p><strong>Üveg:</strong> Ha prémium megjelenés és tökéletes átlátszóság a cél, és a költségvetés engedi.</p>
      <p><strong>Polikarbonát:</strong> Ha jó ár-érték arányú, tartós és könnyen telepíthető megoldást keres. Az opál változat kellemes, szórt fényt biztosít.</p>
    `
  },
  "zip-screen-arnyekolok-elonyei": {
    title: "ZIP screen árnyékolók: A modern megoldás",
    excerpt: "Miért a ZIP screen technológia a legmodernebb árnyékolási megoldás?",
    category: "Tippek és tanácsok",
    date: "2026. január 3.",
    author: "BRS Terasz",
    image: "/images/arnyekolok/ref-arnyekolo-1.webp",
    readTime: "5 perc olvasás",
    refKey: "arnyekolok",
    content: `
      <p>A hagyományos árnyékolókkal szemben a ZIP screen technológia forradalmi megoldást kínál. Miért válasszunk ZIP screen árnyékolót? Összegyűjtöttük a legfontosabb előnyöket.</p>

      <h2>Mi az a ZIP screen?</h2>
      <p>A ZIP screen rendszerben a szövet szélei egy alumínium vezetősínbe záródnak (innen a "zip" név). Ez biztosítja, hogy a szövet teljesen kifeszüljön és még erős szélben sem lobogjon.</p>

      <h2>Oldalárnyékolóként</h2>
      <ul>
        <li><strong>Szélvédelem:</strong> A ZIP rendszer akár 100 km/h szélsebességig is ellenáll.</li>
        <li><strong>Rovarvédelem:</strong> A teljesen zárt rendszer nem enged be rovarokat sem.</li>
        <li><strong>UV védelem:</strong> A speciális szövetek akár a sugárzás 95%-át is kiszűrik.</li>
      </ul>

      <h2>Tetőárnyékolóként</h2>
      <ul>
        <li><strong>Hővédelem:</strong> Nyáron akár 10-15 fokkal csökkenti a terasz hőmérsékletét.</li>
        <li><strong>Automatizálható:</strong> Időzítővel és napfényérzékelővel is kiegészíthető.</li>
        <li><strong>Energiatakarékos:</strong> Csökkenti a belső terek hűtési igényét.</li>
      </ul>

      <h2>Színválaszték</h2>
      <p>Standard alumínium színeink: antracit, fekete, fehér, szürke. Egyedi színek kérésre is készülnek. A szövetek széles szín- és mintaválasztékban érhetők el.</p>
    `
  },
  "kocsibeallo-valasztasi-utmutato": {
    title: "Hogyan válasszunk kocsibeállót? Útmutató",
    excerpt: "Minden amit tudni kell a kocsibeálló vásárlás előtt.",
    category: "Tippek és tanácsok",
    date: "2025. december 20.",
    author: "BRS Terasz",
    image: "/images/kocsibeallok/kocsi4.webp",
    readTime: "5 perc olvasás",
    refKey: "kocsibeallok",
    content: `
      <p>A kocsibeálló kiválasztása fontos döntés. Ebben a cikkben összegyűjtöttük a legfontosabb szempontokat.</p>

      <h2>Méret meghatározása</h2>
      <p>Az első és legfontosabb kérdés: hány autót szeretne védeni?</p>
      <ul>
        <li><strong>Egy autós:</strong> Minimum 3x5 méter alapterület</li>
        <li><strong>Két autós:</strong> Minimum 5.5x5 méter alapterület</li>
        <li><strong>Három autós:</strong> Minimum 8x5 méter alapterület</li>
      </ul>

      <h2>Fedőanyag választás</h2>
      <ul>
        <li><strong>Polikarbonát:</strong> Könnyű, UV álló, jó ár-érték arány. 16 mm és 25 mm vastagságban érhető el, opál vagy víztiszta színben.</li>
        <li><strong>Üveg:</strong> Elegánsabb megjelenés, nagyobb teherbírás</li>
      </ul>

      <h2>Színek</h2>
      <p>Standard alumínium színeink: antracit, fekete, fehér, szürke. Egyedi színeket kérésre is készítünk.</p>

      <h2>Kiegészítők</h2>
      <ul>
        <li>Oldalfalak - extra védelem szél ellen</li>
        <li>LED világítás</li>
        <li>Esővíz-elvezető rendszer</li>
      </ul>
    `
  },
  "terasz-trendek-2025": {
    title: "Terasz trendek 2025-ben: A legújabb stílusok",
    excerpt: "Fedezze fel a 2025-ös év legmenőbb terasz és árnyékolási trendjeit.",
    category: "Inspirációk",
    date: "2025. december 12.",
    author: "BRS Terasz",
    image: "/images/aluminium-teraszok/szabadon-allo-teraszok-1.webp",
    readTime: "6 perc olvasás",
    refKey: "aluminium-teraszok",
    content: `
      <p>2026-ben a kültéri életterek kialakításában több izgalmas trend is megfigyelhető. Mutatjuk a legfontosabbakat!</p>

      <h2>1. Nyitható-zárható terek</h2>
      <p>Az eltolható üvegfalú teraszok egyre népszerűbbek, mivel egész évben használható életteret biztosítanak. Szép időben teljesen kinyithatók, rossz időben pedig teljes védelmet nyújtanak.</p>

      <h2>2. Okos árnyékolás</h2>
      <p>A motoros ZIP screen árnyékolórendszerek, amelyek időjárás-érzékelőkkel vannak felszerelve, egyre keresettebbek. Automatikusan alkalmazkodnak a napfényhez.</p>

      <h2>3. Minimalista design</h2>
      <p>A letisztult vonalvezetés és az egyszínű felületek dominálnak. Az antracit, matt fekete és fehér színek a legnépszerűbbek az alumínium szerkezeteknél.</p>

      <h2>4. Multifunkcionalitás</h2>
      <p>A teraszok egyre többféle funkciót kapnak: konyha, étkező, nappali - a kültéri tér a belső tér meghosszabbítása.</p>

      <h2>5. Fénykontroll</h2>
      <p>A tetőárnyékolók és az oldalárnyékolók kombinációja lehetővé teszi a fény teljes kontrollját. A ZIP screen technológia ebben kiemelten hatékony.</p>
    `
  }
};

// ============ BLOG CATEGORIES ============
export const blogCategories = [
  { id: "all", label: "Összes" },
  { id: "tippek", label: "Tippek és tanácsok" },
  { id: "inspiraciok", label: "Inspirációk" },
];
